/* eslint-disable no-param-reassign */

export default {
  setProjectBaselines(state, { projectId, baselines }) {
    state.projectBaselines = { ...state.projectBaselines, ...{ [projectId]: baselines }};
  },

  addBaseline(state, baseline) {
    state.projectBaselines[baseline.gantt_id].push(baseline);
  },

  updateBaseline(state, updatedBaseline) {
    const index = state.projectBaselines[updatedBaseline.gantt_id].findIndex(item => item.id === updatedBaseline.id);

    if (index !== -1) {
      state.projectBaselines[updatedBaseline.gantt_id].splice(index, 1, updatedBaseline);
    }
  },

  removeBaseline(state, baseline) {
    const index = state.projectBaselines[baseline.gantt_id].findIndex(item => item.id === baseline.id);

    if (index !== -1) {
      state.projectBaselines[baseline.gantt_id].splice(index, 1);
    }
  },

  addProjectBaselineData(state, { projectId, eventId, data }) {
    if (!state.projectBaselineData[projectId]) {
      state.projectBaselineData[projectId] = {};
    }
    state.projectBaselineData[projectId][eventId] = Object.freeze(data);
  },

  enableBaseline(state, baseline) {
    state.enabledBaselines[baseline.gantt_id] = baseline;
  },

  disableBaseline(state, baseline) {
    delete state.enabledBaselines[baseline.gantt_id];
  },
};
